
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podatek-rolny",
      function () {
        return require("private-next-pages/podatek-rolny/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podatek-rolny"])
      });
    }
  